import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
 
const Footer: React.FC = () => {
  const [showCZBar, setShowCZBar] = useState(false);
  const [isTelephonyLoggedIn, setIsTelephonyLoggedIn] = useState(false);
  const tenantName = window.location.hostname.split(".")[0];
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
 const [manuallyClosed, setManuallyClosed] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
 
    window.addEventListener("resize", handleResize);
 
    return () => window.removeEventListener("resize", handleResize);
  }, []);
 
  // const toggleCZBar = () => {
  //   setShowCZBar((prev) => !prev);
  // };
  const toggleCZBar = () => {
  setShowCZBar((prev) => {
    const newState = !prev;
    setManuallyClosed(!newState); // If closing, mark as manually closed
    return newState;
  });
};

 
//   useEffect(() => {
//     const checkLogin = () => {
//       const loginStatus = localStorage.getItem("telephony_login") === "true";
//       setIsTelephonyLoggedIn(loginStatus);
 
//       // ✅ Auto-open iframe on login
//       // if (tenantName === "cloudtelephony" && loginStatus) {
//       if ((tenantName === "cloudtelephony" || tenantName === "cslfinance") && loginStatus) {
//         setShowCZBar(true);
//       }
 
//       // ✅ Auto-close iframe on logout
//       if (!loginStatus) {
//         setShowCZBar(false);
//       }
//     };
 
//     checkLogin();
//     const interval = setInterval(checkLogin, 1000);
//     return () => clearInterval(interval);
//   }, [tenantName]);
 
  useEffect(() => {
  const checkLogin = () => {
    const loginStatus = localStorage.getItem("telephony_login") === "true";
    setIsTelephonyLoggedIn(loginStatus);

    if ((tenantName === "cloudtelephony" || tenantName === "cslfinance") && loginStatus && !manuallyClosed) {
      setShowCZBar(true);
    }

    if (!loginStatus) {
      setShowCZBar(false);
      setManuallyClosed(false); // Reset manual close on logout
    }
  };

  checkLogin();
  const interval = setInterval(checkLogin, 1000);
  return () => clearInterval(interval);
}, [tenantName, manuallyClosed]);

  return (
    <>
      <footer className="bg-white text-white text-center py-3 mt-auto mx-n3">
        <Container>
          <div className="text-dark order-2 order-md-1">
            <span className="text-muted fw-bold me-2">
              &copy;{new Date().getFullYear()} &nbsp;
              <a
                href="https://botgo.io/"
                className="text-gray-500 text-hover-primary"
              >
                CircleOne CRM - Powered By BOTGO Technologies &nbsp;
              </a>
              All Rights Reserved
            </span>
          </div>
        </Container>
 
        {/* 📞 Telephony Button (for cloudtelephony tenant only) */}
{(tenantName === "cloudtelephony" || tenantName === "cslfinance") && isTelephonyLoggedIn && ( 
   <div
    style={{
      position: "fixed", // 🔄 changed from "absolute"
      bottom: "-3px",     // 🔧 adjust spacing as needed
      left: "123px",
      backgroundColor: "#fff",
      borderRadius: "50%",
      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      padding: "10px",
      cursor: "pointer",
      zIndex: 10000,      // ⬆️ ensure it's above other UI
    }}
    onClick={toggleCZBar}
    title={showCZBar ? "Close CZ-Bar" : "Open CZ-Bar"}
  >
    <i
      className="bi bi-telephone"
      style={{ fontSize: "20px", color: "#007bff" }}
    ></i>
  </div>
)}
 
        {/* 📶 CZ-Bar Iframe Panel */}
        {showCZBar && (
        <div
          style={{
            position: "fixed",
            bottom: "80px",
            left: "40px",
            width: "320px",
            height: "355px",
            overflow: "hidden",
            zIndex: 9999,
          }}
        >
          {/* The iframe will re-render whenever windowWidth changes */}
          <iframe
            key={windowWidth}
            src="https://agent.c-zentrixcloud.com/czapp/cti_handler.php"
            style={{
              width: "100%",
              height: "100%",
              border: "none",
              display: "block",
            }}
            title="CZ-Bar"
            allow="microphone; camera; autoplay; notifications; encrypted-media"
          ></iframe>
        </div>
      )}
      </footer>
    </>
  );
};
 
export default Footer;